import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=3285ad56&"
import script from "./AppNav.vue?vue&type=script&lang=js&"
export * from "./AppNav.vue?vue&type=script&lang=js&"
import style0 from "./AppNav.vue?vue&type=style&index=0&id=3285ad56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports